import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Dashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header */}
      <nav className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-indigo-600">MyAI English Learning</h1>
          <div className="flex items-center gap-4">
            <span className="text-gray-700">Welcome, {user?.username}!</span>
            <button
              onClick={() => navigate('/invitations')}
              className="bg-purple-500 text-white px-4 py-2 rounded-lg hover:bg-purple-600 transition"
            >
              🎫 Invitations
            </button>
            <button
              onClick={handleLogout}
              className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
            >
              Logout
            </button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* User Stats */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4">Your Progress</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-indigo-50 p-4 rounded-lg">
              <p className="text-gray-600">Current Level</p>
              <p className="text-3xl font-bold text-indigo-600">{user?.current_level}</p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg">
              <p className="text-gray-600">Total Points</p>
              <p className="text-3xl font-bold text-green-600">{user?.total_points}</p>
            </div>
            <div className="bg-purple-50 p-4 rounded-lg">
              <p className="text-gray-600">Member Since</p>
              <p className="text-xl font-bold text-purple-600">
                {new Date(user?.created_at || '').toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>

        {/* Learning Modules */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <button
            onClick={() => navigate('/chat')}
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition transform hover:-translate-y-1"
          >
            <div className="text-4xl mb-4">💬</div>
            <h3 className="text-xl font-bold mb-2">Conversation Practice</h3>
            <p className="text-gray-600">Chat with AI tutor in English</p>
          </button>

          <button
            onClick={() => navigate('/srs')}
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition transform hover:-translate-y-1"
          >
            <div className="text-4xl mb-4">🎴</div>
            <h3 className="text-xl font-bold mb-2">Vocabulary (SRS)</h3>
            <p className="text-gray-600">Learn words with spaced repetition</p>
          </button>

          <button
            onClick={() => navigate('/reading')}
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition transform hover:-translate-y-1"
          >
            <div className="text-4xl mb-4">📖</div>
            <h3 className="text-xl font-bold mb-2">Reading Practice</h3>
            <p className="text-gray-600">Read articles and answer questions</p>
          </button>

          <div className="bg-white p-6 rounded-lg shadow-lg opacity-50 cursor-not-allowed">
            <div className="text-4xl mb-4">🎧</div>
            <h3 className="text-xl font-bold mb-2">Listening Practice</h3>
            <p className="text-gray-600">Coming soon...</p>
          </div>
        </div>

        {/* Quick Tips */}
        <div className="mt-8 bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-bold mb-4">💡 Quick Tips</h2>
          <ul className="space-y-2 text-gray-700">
            <li>• Practice daily for at least 15 minutes to see progress</li>
            <li>• Don't be afraid to make mistakes - they help you learn!</li>
            <li>• Use the SRS system to remember new vocabulary effectively</li>
            <li>• Read articles to improve comprehension and expand vocabulary</li>
            <li>• Try to think in English when chatting</li>
            <li>• Invite friends to learn together using the invitation system</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
